{
  "version": 1,
  "asset_id": "6aec8fb7-5036-4bfe-98ad-c7fa14db5940",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6aec8fb7-5036-4bfe-98ad-c7fa14db5940/cargo-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6aec8fb7-5036-4bfe-98ad-c7fa14db5940/cargo-hero.webp",
  "original_filename": "cargo-hero.webp",
  "size": 40806,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:51Z"
}
